import {
  GET_LEADERBOARD_LOADING,
  GET_LEADERBOARD_SUCCESS,
  GET_LEADERBOARD_ERROR,
  CLEAR_LEADERBOARD_DATA,
} from "../../../constant/actionTypes";

const getProjectedScoresByID = (state = {}, action) => {
  switch (action.type) {
    case GET_LEADERBOARD_LOADING: {
      let obj = {
        loading: true,
      };
      return obj;
    }
    case GET_LEADERBOARD_SUCCESS: {
      let obj = {
        loading: false,
        data: action.response,
      };
      return obj;
    }
    case GET_LEADERBOARD_ERROR: {
      let obj = {
        loading: false,
        status: action.response,
      };
      return obj;
    }
    case CLEAR_LEADERBOARD_DATA: {
      let obj = {
        loading: false,
        data: undefined,
      };
      return obj;
    }
    default:
      return state;
  }
};

export default getProjectedScoresByID;
